import { Link, createBrowserRouter } from "react-router-dom";
import Login from "../pages/Login/Login";
import DashbordHome from "../pages/Dashboard/DashboardHome";
import Dashboard from "../pages/Dashboard/Dashboard";
import RequireAuth from "../components/PrivateRoute/RequireAuth";
import Users from "../pages/Login/Users";
import CreateUser from "../pages/Login/CreateUser";
import UpdateUser from "../pages/Login/UpdateUser";
import SubCategory from "../pages/CategoryManagement/SubCategory/SubCategory";
import Product from "../pages/CategoryManagement/Product/Product";
import Warehouse from "../pages/Warehouse/Warehouse";
import SalesPrice from "../pages/Sales/SalesPrice/SalesPrice";
import SalesRateRepeat from "../pages/Sales/SalesPrice/SalesRateRepeat";
import OrderUpdate from "../pages/Sales/SalesProduct/OrderUpdate";
import OrderCreate from "../pages/Sales/SalesProduct/OrderCreate";
import UpdateOrderProduct from "../pages/Sales/SalesProduct/UpdateOrderProduct";
import Orders from "../pages/Sales/SalesProduct/Orders";
import ReportGenerate from "../pages/Sales/SalesProduct/ReportGenerate/ReportGenerate";
import Purchase from "../pages/Purchase/Purchase";
import CreatePurchase from "../pages/Purchase/CreatePurchase";
import UpdatePurchase from "../pages/Purchase/UpdatePurchase";
import DateWisePurchaseReport from "../pages/AllReports/PurchaseReports/DateWisePurchaseReport";
import StockReport from "../pages/AllReports/StockReport/StockReport";
import Supplier from "../pages/Dealer&Supplier/SupplierManagement/Supplier";
import Dealer from "../pages/Dealer&Supplier/DealerManagement/Dealer";
import ReturnProduct from "../pages/Return/ReturnProduct";
import DamageProduct from "../pages/Return/DamageProduct";
import CreateDamage from "../pages/Return/CreateDamage";
import LedgerList from "../pages/Ledger/LedgerList";
import CreateLedger from "../pages/Ledger/CreateLedger";
import CashReceive from "../pages/Ledger/CashReceive";
import DealerStatement from "../pages/Ledger/DealerStatement";
import DealerSummary from "../pages/Ledger/DealerSummary";
import CashPayment from "../pages/Ledger/CashPayment";
import SupplierStatement from "../pages/Ledger/SupplierStatement";
import Receipt from "../pages/Ledger/Receipt";
import ReceiptSup from "../pages/Ledger/ReceiptSup";
import ReturnProductList from "../pages/Return/ReturnProductList";
import ReturnCreate from "../pages/Return/ReturnCreate";
import DailyPurchaseReport from "../pages/AllReports/PurchaseReports/DailyPurchaseReport";
import DailySalesReport from "../pages/AllReports/SalesReports/DailySalesReport";
import DateWiseSalesReport from "../pages/AllReports/SalesReports/DateWiseSalesReport";
import BankInfo from "../pages/BankTransaction/BankInfo/BankInfo";
import BankDeposit from "../pages/BankTransaction/BankDeposit/BankDeposit";
import CreateBankInfo from "../pages/BankTransaction/BankInfo/CreateBankInfo";
import CreateBankDeposit from "../pages/BankTransaction/BankDeposit/CreateBankDeposit";
import Unit from "../pages/CategoryManagement/Unit/Unit";
import ReturnReport from "../pages/Return/ReturnReport";
import ExpenseSummary from "../pages/Expenses/ExpenseSummary";
import ExpenseItem from "../pages/Expenses/ExpenseItem";
import CreateExpense from "../pages/Expenses/CreateExpense";
import UpdateExpense from "../pages/Expenses/UpdateExpense";
import ReportWithoutDue from "../pages/Sales/SalesProduct/ReportGenerate/ReportWithoutDue";
import Challan from "../pages/Challan/Challan";
import CreateChallan from "../pages/Challan/CreateChallan";
import ChallanReport from "../pages/Challan/ChallanReport";
import Quotation from "../pages/Quotation/Quotation";
import QuotationItems from "../pages/Quotation/QuotationItems";
import CreateQuotation from "../pages/Quotation/CreateQuotation";
import UpdateQuotation from "../pages/Quotation/UpdateQuotation";
import QuotationReport from "../pages/Quotation/QuotationReport";
import ProService from "../pages/ProService/ProService";
import UpdateProService from "../pages/ProService/UpdateProService";
import ProserviceReport from "../pages/ProService/ProserviceReport";
import ProServiceJobReport from "../pages/ProService/ProServiceJobReport";
import Testing from "../pages/Sales/SalesProduct/ReportGenerate/Testing";
import TransactionReport from "../pages/AllReports/TransactionReport/TransactionReport";
import CollectionReports from "../pages/AllReports/CollectionReports/CollectionReports";
import PaymentReport from "../pages/AllReports/CollectionReports/PaymentReport";
import StockBook from "../pages/AllReports/StockReport/StockBook";
import Subjects from "../pages/CategoryManagement/Subjects/Subjects";
import SubItem from "../pages/Expenses/SubItem/SubItem";
import SubItemList from "../pages/Expenses/SubItemList/SubItemList";
import ProServiceBill from "../pages/ProService/ProServiceBill";
import CreateProService from "../pages/ProService/CreateProService";
import ViewUpdateProService from "../pages/ProService/ViewUpdateProService";
import ContactUs from "../pages/Website/ContactUs/ContactUs";
import MessageView from "../pages/Website/ContactUs/MessageView";
import Products from "../pages/Website/Products/Products";
import CreateProduct from "../pages/Website/Products/CreateProduct";
import ViewUpdateProduct from "../pages/Website/Products/ViewUpdateProduct";
import ClaimFormView from "../pages/ProService/ClaimFormView";
import DeliveryFormView from "../pages/ProService/DeliveryFormView";
import PurchaseView from "../pages/Purchase/PurchaseView";
import PendingCollection from "../pages/Ledger/PendingCollection";
// import CreateProService from "../pages/ProService/CreateProservice";
const routes = createBrowserRouter([
  {
    path: "/",
    element: <Login />,
  },
  {
    path: "/dashboard",
    element: (
      <RequireAuth>
        <Dashboard />
      </RequireAuth>
    ),
    children: [
      {
        path: "/dashboard",
        element: <DashbordHome />,
      },
      {
        path: "/dashboard/user",
        element: <Users />,
      },
      {
        path: "/dashboard/user/create",
        element: <CreateUser />,
      },
      {
        path: "/dashboard/user/edit",
        element: <UpdateUser />,
      },
      {
        path: "/dashboard/ledger-list",
        element: <LedgerList />,
      },
      {
        path: "/dashboard/create-ledger",
        element: <CreateLedger />,
      },
      {
        path: "/dashboard/cash-receive",
        element: <CashReceive />,
      },
      {
        path: "/dashboard/cash-payment",
        element: <CashPayment />,
      },
      {
        path: "/dashboard/supplier-statement",
        element: <SupplierStatement />,
      },
      {
        path: "/dashboard/dealer-statement",
        element: <DealerStatement />,
      },
      {
        path: "/dashboard/dealer-summary",
        element: <DealerSummary />,
      },
      {
        path: "/dashboard/dealer/receipt",
        element: <Receipt />,
      },
      {
        path: "/dashboard/supplier/receipt",
        element: <ReceiptSup />,
      },
      {
        path: "/dashboard/sub_category",
        element: <SubCategory />,
      },
      {
        path: "/dashboard/product",
        element: <Product />,
      },
      {
        path: "/dashboard/subjects",
        element: <Subjects />,
      },
      {
        path: "/dashboard/dealer",
        element: <Dealer />,
      },
      {
        path: "/dashboard/supplier",
        element: <Supplier />,
      },
      {
        path: "/dashboard/warehouse",
        element: <Warehouse />,
      },
      {
        path: "/dashboard/purchase",
        element: <Purchase />,
      },
      {
        path: "/dashboard/purchase-view/:purId",
        element: <PurchaseView />,
      },
      {
        path: "/dashboard/createPurchase",
        element: <CreatePurchase />,
      },
      {
        path: "/dashboard/updatePurchase",
        element: <UpdatePurchase />,
      },
      {
        path: "/dashboard/rate",
        element: <SalesPrice />,
      },
      {
        path: "/dashboard/repeat",
        element: <SalesRateRepeat />,
      },
      {
        path: "/dashboard/salesReturnList",
        element: <ReturnProductList />,
      },
      {
        path: "/dashboard/returnProduct/create",
        element: <ReturnCreate />,
      },
      {
        path: "/dashboard/orders",
        element: <Orders />,
      },
      {
        path: "/dashboard/order/updateProduct",
        element: <UpdateOrderProduct />,
      },
      {
        path: "/dashboard/orders/create",
        element: <OrderCreate />,
      },
      {
        path: "/dashboard/quotation",
        element: <Quotation />,
      },
      {
        path: "/dashboard/quotation/items",
        element: <QuotationItems />,
      },
      {
        path: "/dashboard/quotation/create",
        element: <CreateQuotation />,
      },
      {
        path: "/dashboard/quotation/edit",
        element: <UpdateQuotation />,
      },
      {
        path: "/dashboard/quotation/report",
        element: <QuotationReport />,
      },
      {
        path: "/dashboard/product-services",
        element: <ProService />,
      },
      {
        path: "/dashboard/product-services-bill",
        element: <ProServiceBill />,
      },
      {
        path: "/dashboard/product-service/create",
        element: <CreateProService />,
      },
      {
        path: "/dashboard/product-service/view",
        element: <ViewUpdateProService />,
      },
      {
        path: "/dashboard/product-service/edit",
        element: <UpdateProService />,
      },
      {
        path: "/dashboard/product-service/report/:id",
        element: <ProserviceReport />,
      },
      {
        path: "/dashboard/product-service/job-report/:id",
        element: <ProServiceJobReport />,
      },
      {
        path: "/dashboard/product-service/claim-form/:id",
        element: <ClaimFormView />,
      },
      {
        path: "/dashboard/product-service/delivery-form/:id",
        element: <DeliveryFormView />,
      },
      {
        path: "/dashboard/test",
        element: <Testing />,
      },
      {
        path: "/dashboard/challan",
        element: <Challan />,
      },
      {
        path: "/dashboard/challan/create",
        element: <CreateChallan />,
      },
      {
        path: "/dashboard/challan/report/:chId",
        element: <ChallanReport />,
      },
      {
        path: "/dashboard/orders/update",
        element: <OrderUpdate />,
      },
      {
        path: "/dashboard/order/invoice/:invId",
        element: <ReportGenerate />,
      },
      {
        path: "/dashboard/order/invoice/report",
        element: <ReportWithoutDue />,
      },
      {
        path: "/dashboard/returnProduct",
        element: <ReturnProduct />,
      },
      {
        path: "/dashboard/returnProduct/invoice",
        element: <ReturnReport />,
      },
      {
        path: "/dashboard/damageProduct",
        element: <DamageProduct />,
      },
      {
        path: "/dashboard/create-damage",
        element: <CreateDamage />,
      },
      {
        path: "/dashboard/report/purchase",
        element: <DateWisePurchaseReport />,
      },
      {
        path: "/dashboard/report/purchase/daily",
        element: <DailyPurchaseReport />,
      },
      {
        path: "/dashboard/report/sales",
        element: <DateWiseSalesReport />,
      },
      {
        path: "/dashboard/report/sales/daily",
        element: <DailySalesReport />,
      },
      {
        path: "/dashboard/report/stock",
        element: <StockReport />,
      },
      {
        path: "/dashboard/report/stock",
        element: <StockReport />,
      },
      {
        path: "/dashboard/report/stock/sales",
        element: <StockBook />,
      },
      {
        path: "/dashboard/bankinfo",
        element: <BankInfo />,
      },
      {
        path: "/dashboard/bankdeposit",
        element: <BankDeposit />,
      },
      {
        path: "/dashboard/bankinfo-create",
        element: <CreateBankInfo />,
      },
      {
        path: "/dashboard/bankdeposit-create",
        element: <CreateBankDeposit />,
      },
      {
        path: "/dashboard/models",
        element: <Unit />,
      },
      {
        path: "/dashboard/expenses/summary",
        element: <ExpenseSummary />,
      },
      {
        path: "/dashboard/expenses/item",
        element: <ExpenseItem />,
      },
      {
        path: "/dashboard/expenses/create",
        element: <CreateExpense />,
      },
      {
        path: "/dashboard/expenses/update",
        element: <UpdateExpense />,
      },
      {
        path: "/dashboard/expenses/sub-item",
        element: <SubItem />,
      },
      {
        path: "/dashboard/expenses/sub-item-list",
        element: <SubItemList />,
      },
      {
        path: "/dashboard/transaction/report",
        element: <TransactionReport />,
      },
      {
        path: "/dashboard/collection/report",
        element: <CollectionReports />,
      },
      {
        path: "/dashboard/payment/report",
        element: <PaymentReport />,
      },

      // website
      {
        path: "/dashboard/website/contact",
        element: <ContactUs />,
      },
      {
        path: "/dashboard/website/contact-message",
        element: <MessageView />,
      },
      {
        path: "/dashboard/website/products",
        element: <Products />,
      },
      {
        path: "/dashboard/website/product-create",
        element: <CreateProduct />,
      },
      {
        path: "/dashboard/website/product-view/:id",
        element: <ViewUpdateProduct />,
      },
      {
        path: "/dashboard/pending-collection",
        element: <PendingCollection />,
      },
    ],
  },
  {
    path: "*",
    element: (
      <h1>
        Page not found go{" "}
        <Link to="/dashboard" className="text-blue-500 underline">
          home
        </Link>
      </h1>
    ),
  },
]);

export default routes;
